import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path1/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "page-settings"
    }}>{`Page Settings`}</h1>
    <p>{`To override any global theme settings(customizer settings) for an specific page there is a page settings in every page. From that page settings you can set quite a few specific settings for that page. Suppose you want to turn off banner for a page then you can easily do that from `}<inlineCode parentName="p">{`Page Settings`}</inlineCode></p>
    <p>{`First scroll down to the bottom to any page and you will find the below settings panel`}</p>
    <p><img alt="14. Theme Settings.png" src="https://res.cloudinary.com/redq-inc/image/upload/v1595966379/cartsy_doc/page_settings_wj0h8q.png" /></p>
    <p>{`Now suppose if you want to turn off the page banner then goto General tab and change specific settings. Check below image`}</p>
    <p><img alt="15. Banner Option.png" src="https://res.cloudinary.com/redq-inc/image/upload/v1595966432/cartsy_doc/banner_cn6dat.png" /></p>
    <p>{`After going to the `}<inlineCode parentName="p">{`General`}</inlineCode>{` tab change the Select Option from `}<inlineCode parentName="p">{`Global`}</inlineCode>{` to `}<inlineCode parentName="p">{`Local`}</inlineCode>{` then turn `}<inlineCode parentName="p">{`Page Banner`}</inlineCode>{` off from next settings. Follow the arrow sign.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      